<template>
  <div class="container">
    <van-tabs v-model="active">
      <van-tab title="走访信息">
        <details-info :infoResult="infoResult"></details-info>
      </van-tab>
      <van-tab title="进度详情">
        <details-progress ref="progress"></details-progress>
      </van-tab>
    </van-tabs>
    <div class="btn-wrap" v-if="infoResult.status == 1">
      <div class="btn-list" @click="dialogTap(1)">拒绝邀请</div>
      <div class="btn-list btn-color" @click="dialogTap(2)">接受邀请</div>
    </div>
    <div class="btn-wrap" v-if="infoResult.status == 7">
      <div class="btn-evaluate" @click="evaluateShow = true">评价</div>
    </div>
    <div class="btn" v-if="showBtn && active == 0">
      <van-button square plain type="danger" @click="deleteDialog"
        >删除</van-button
      >
      <van-button square plain type="info" @click="edit">修改信息</van-button>
    </div>
    <!-- 接受、拒绝邀请弹窗 -->
    <van-dialog
      v-model="dialogShow"
      :title="dialogTitle"
      confirmButtonColor="#0084FF"
      show-cancel-button
      @confirm="dialogConfirm"
    >
      <div class="form-item" v-if="dialogValue == 1" @click="dataShow = true">
        <van-field
          v-model="time"
          placeholder="点击选择修改时间"
          left-icon="calendar-o"
          readonly
        />
      </div>
      <van-field
        v-model="message"
        rows="2"
        autosize
        type="textarea"
        maxlength="200"
        placeholder="请输入备注"
        show-word-limit
      />
    </van-dialog>
    <!-- 时间选择弹窗 -->
    <van-calendar
      v-model="dataShow"
      color="#1989FA"
      :show-confirm="false"
      @select="dataConfirm"
    />
    <van-popup v-model="timePickerStart" round position="bottom">
      <van-datetime-picker
        v-model="timeStartValue"
        type="time"
        title="选择开始时间"
        cancel-button-text="重置"
        @cancel="timeCancel"
        @confirm="timeConfirmStart"
      />
    </van-popup>
    <van-popup v-model="timePickerEnd" round position="bottom">
      <van-datetime-picker
        v-model="timeEndValue"
        type="time"
        title="选择结束时间"
        cancel-button-text="重置"
        @cancel="timeCancel"
        @confirm="timeConfirmEnd"
      />
    </van-popup>
    <!-- 评价弹窗 -->
    <van-dialog
      class="evaluate-dialog"
      v-model="evaluateShow"
      title="企业评价"
      confirmButtonColor="#0084FF"
      show-cancel-button
      @confirm="evaluateConfirm"
    >
      <van-rate
        class="rate"
        v-model="rateValue"
        :size="25"
        color="#3366FF"
        void-icon="star"
        void-color="#eee"
        @change="rateChange"
      />
      <div class="rate-text">{{ rateText }}</div>
      <van-field
        class="rateMessage"
        v-model="rateMessage"
        rows="5"
        type="textarea"
        placeholder="请填写更多评价反馈，有助于我们改善"
        show-word-limit
      />
    </van-dialog>
  </div>
</template>
<script>
import detailsInfo from './components/detailsInfo'
import detailsProgress from './components/detailsProgress'
import {
  visitDetail,
  acceptVisit,
  entEvaluate,
  commerType,
  commerStatus,
  delVisit
} from '@api/commissioner/commissioner'
import { Toast, Dialog } from 'vant'
export default {
  components: {
    detailsInfo,
    detailsProgress
  },
  data() {
    return {
      showBtn: false,
      active: 0,
      dialogShow: false,
      dialogValue: '',
      dialogTitle: '',
      message: '', // 接受、拒绝理由
      evaluateShow: false,
      rateValue: 5, // 评分
      rateText: '非常满意',
      rateMessage: '',
      infoResult: {
        // 走访信息
        userId: '',
        status: '',
        title: '',
        initiator: '',
        link: '',
        staff: '', // 专员
        part: '', // 企业名称
        person: '', // 联系对象
        phone: '', // 联系电话
        time: '', // 预约时间
        text: '', // 描述
        visit: '', // 走访记录
        imgs: [], // 走访记录图片
        rateValue: 5, // 评价星级
        rateMessage: '' // 评价
      },
      time: '', // 预约时间
      dataShow: false, // 日期选择弹窗
      dataText: '', // 日期单天
      timePickerStart: false, // 开始时间弹窗
      timePickerEnd: false, // 结束时间弹窗
      timeStartValue: '', // 开始时间
      timeEndValue: '', // 结束时间
      disable: false
    }
  },
  mounted() {
    this.getInfo()
  },
  watch: {},
  methods: {
    // 删除该条申请
    deleteDialog() {
      if (this.disable) return
      this.disable = true
      Dialog.confirm({
        title: '删除走访',
        message:
          '在专员处理您的邀请前，都可以撤回本次走访，撤回即代表删除，是否继续？'
      })
        .then(() => {
          this.delete()
        })
        .catch(() => {
          this.disable = false
        })
    },
    // 删除操作
    delete() {
      delVisit({ id: this.$route.query.id })
        .then((res) => {
          const { code, msg } = res.data
          if (code == '0000') {
            this.$notify({
              type: 'success',
              message: '删除成功',
              onClose: () => {
                this.$router.push({
                  path: '/commissioner/index'
                })
              }
            })
          } else {
            Dialog.alert({
              message: msg
            }).then(() => {
              this.disable = false
              this.getInfo()
            })
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    edit() {
      if (this.disable) return
      // 跳转到编辑/commissioner/invitation
      this.$router.replace({
        path: '/commissioner/invitation',
        query: {
          commerId: this.$route.query.id,
          id: this.infoResult.userId
        }
      })
    },
    getInfo() {
      visitDetail({ id: this.$route.query.id }).then((res) => {
        const { code, data, msg } = res.data
        if (code == '0000') {
          let imgs = []
          if (data.fileList) {
            data.fileList.forEach((item) => {
              imgs.push(item.uploadUrl)
            })
          }
          this.infoResult.status = data.commerStatus
          this.infoResult.title = data.commerTitle
          this.infoResult.initiator = commerType(data.commerType)
          this.infoResult.link = commerStatus(data.commerStatus)
          this.infoResult.staff = data.name
          this.infoResult.part = data.entName
          this.infoResult.person = data.contactPerson
          this.infoResult.phone = data.contactPhone
          this.infoResult.time =
            data.startTime + ' - ' + data.endTime.split(' ')[1]
          this.infoResult.text = data.notes
          this.infoResult.visit = data.visitRecord
          this.infoResult.imgs = imgs
          this.infoResult.rateValue = data.starLevel
          this.infoResult.rateMessage = data.remarks || '未评价，系统默认好评'
          this.infoResult.userId = data.userId || ''
          if (data.commerType == 1 && data.commerStatus == 2) {
            this.showBtn = true
          } else {
            this.showBtn = false
          }
        } else {
          Toast(msg)
        }
      })
    },
    formatDate(date) {
      return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
    },
    dataConfirm(e) {
      this.time = ''
      this.dataText = this.formatDate(e)
      this.dataShow = false
      this.timePickerStart = true
    },
    timeConfirmStart(e) {
      this.timeStartValue = e
      this.timePickerStart = false
      this.timePickerEnd = true
    },
    timeConfirmEnd(e) {
      this.time = this.dataText + ' ' + this.timeStartValue + ' - ' + e
      this.timeEndValue = e
      this.timePickerEnd = false
    },
    timeCancel() {
      this.dataText = ''
      this.timeStartValue = ''
      this.timeEndValue = ''
      this.dataShow = false
      this.timePickerStart = false
      this.timePickerEnd = false
    },
    // 接受拒绝弹窗
    dialogTap(e) {
      this.dialogShow = true
      this.dialogValue = e
      if (e == 1) {
        this.dialogTitle = '拒绝邀请'
      } else {
        this.dialogTitle = '接受邀请'
      }
    },
    // 接受、拒绝邀请
    dialogConfirm() {
      let status, statusText, time
      if (this.dialogValue == 1) {
        status = 2
        statusText = '已拒绝'
        if (this.time) {
          time = '可预约时间：' + this.time + '。'
        } else {
          time = ''
        }
      } else {
        status = 1
        statusText = '已接收'
        time = ''
      }
      let params = {
        status: status,
        id: this.$route.query.id,
        remarks: time + this.message
      }
      acceptVisit(params).then((res) => {
        const { code, data, msg } = res.data
        if (code == '0000') {
          Toast(statusText)
          // 刷新页面数据
          this.getInfo()
          this.$refs.progress.getProgress()
        } else {
          Toast(msg)
        }
      })
    },
    // 评价
    rateChange(e) {
      switch (e) {
        case 1:
          this.rateText = '非常不满意'
          break
        case 2:
          this.rateText = '不满意'
          break
        case 3:
          this.rateText = '一般'
          break
        case 4:
          this.rateText = '满意'
          break
        case 5:
          this.rateText = '非常不满意'
          break
      }
    },
    evaluateConfirm() {
      let params = {
        starLevel: this.rateValue,
        evaluateContent: this.rateMessage,
        id: this.$route.query.id
      }
      entEvaluate(params).then((res) => {
        const { code, data, msg } = res.data
        if (code == '0000') {
          Toast('评价成功！')
          // 刷新页面数据
          this.getInfo()
          this.$refs.progress.getProgress()
        } else {
          Toast(msg)
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.btn {
  width: 100%;
  color: #fff;
  background: opacity;
  text-align: center;
  border-radius: 6px;
  position: fixed;
  bottom: 25px;
  left: 0;
  display: flex;
  justify-content: space-around;
  .van-button__content {
    font-size: 16px;
  }
  /deep/.van-button--default {
    background-color: #eee;
  }
  /deep/.van-button--square {
    width: 45%;
  }
}
.container {
  width: 100%;
  min-height: 100vh;
  background: #f8f9fc;
  padding-bottom: 80px;
  box-sizing: border-box;
}
/deep/.van-tabs__line {
  background: #0091ff;
}
/deep/.van-tabs__wrap {
  background: #fff;
  position: sticky;
  top: 0;
  z-index: 100;
}
.btn-wrap {
  width: 100%;
  position: fixed;
  bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  .btn-list {
    width: 120px;
    text-align: center;
    background: #ccc;
    font-size: 16px;
    padding: 10px 0;
    margin: 0 10px;
    border-radius: 6px;
  }
  .btn-color {
    background: #0084ff;
    color: #fff;
  }
  .btn-evaluate {
    width: 96%;
    text-align: center;
    background: #0084ff;
    color: #fff;
    font-size: 16px;
    padding: 10px 0;
    margin: 0 10px;
    border-radius: 6px;
  }
}
.evaluate-dialog {
  text-align: center;
  /deep/.van-dialog__content {
    padding: 20px 20px 16px;
  }
  .rate-text {
    height: 30px;
    line-height: 30px;
    font-size: 14px;
    color: #3366ff;
  }
  .rateMessage {
    border: 1px solid #ccc;
    border-radius: 4px;
  }
}
.form-item {
  border: 1px solid #ddd;
  margin-top: 10px;
  /deep/.van-icon {
    font-size: 18px;
    margin-right: 8px;
  }
}
</style>
